import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1SignaturesModel extends ModelBase<ReservationType1SignaturesModel, ReservationType1SignaturesDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationTypeId: string | undefined = "";

    @observable
    public propertyId: string = "";

    @observable
    public purchaserOneSignatureUrl: string = "";

    @observable
    public purchaserOneSignatureDataUrl: string = "";

    @observable
    public purchaserOneSignatureDate: string = new Date().toString();

    @observable
    public purchaserTwoSignatureUrl: string = "";

    @observable
    public purchaserTwoSignatureDataUrl: string = "";

    @observable
    public purchaserTwoSignatureDate: string = new Date().toString();

    @observable
    public salesAgentSignatureUrl: string = "";

    @observable
    public salesAgentSignatureDataUrl: string = "";

    @observable
    public salesAgentSignatureDate: string = new Date().toString();
    //#endregion Properties

    @action
    public fromDto = (reservationDto: ReservationType1SignaturesDTO) => {
        this.id = reservationDto.id;
        this.reservationTypeId = reservationDto.reservationTypeId;
        this.propertyId = reservationDto.propertyId;
        this.purchaserOneSignatureUrl = reservationDto.purchaserOneSignatureUrl;
        this.purchaserOneSignatureDataUrl = reservationDto.purchaserOneSignatureDataUrl;
        this.purchaserOneSignatureDate = reservationDto.purchaserOneSignatureDate;
        this.purchaserTwoSignatureUrl = reservationDto.purchaserTwoSignatureUrl;
        this.purchaserTwoSignatureDataUrl = reservationDto.purchaserTwoSignatureDataUrl;
        this.purchaserTwoSignatureDate = reservationDto.purchaserTwoSignatureDate;
        this.salesAgentSignatureUrl = reservationDto.salesAgentSignatureUrl;
        this.salesAgentSignatureDataUrl = reservationDto.salesAgentSignatureDataUrl;
        this.salesAgentSignatureDate = reservationDto.salesAgentSignatureDate;
    };

    public toDto = (): ReservationType1SignaturesDTO => {
        return {
            id: this.id,
            reservationTypeId: this.reservationTypeId,
            propertyId: this.propertyId,
            purchaserOneSignatureUrl: this.purchaserOneSignatureUrl,
            purchaserOneSignatureDataUrl: this.purchaserOneSignatureDataUrl,
            purchaserOneSignatureDate: this.purchaserOneSignatureDate,
            purchaserTwoSignatureUrl: this.purchaserTwoSignatureUrl,
            purchaserTwoSignatureDataUrl: this.purchaserTwoSignatureDataUrl,
            purchaserTwoSignatureDate: this.purchaserTwoSignatureDate,
            salesAgentSignatureUrl: this.salesAgentSignatureUrl,
            salesAgentSignatureDataUrl: this.salesAgentSignatureDataUrl,
            salesAgentSignatureDate: this.salesAgentSignatureDate,
        };
    };
}

export interface ReservationType1SignaturesDTO {
    id: string | undefined;
    reservationTypeId?: string;
    propertyId: string;
    purchaserOneSignatureUrl: string;
    purchaserOneSignatureDataUrl: string;
    purchaserOneSignatureDate: string;
    purchaserTwoSignatureUrl: string;
    purchaserTwoSignatureDataUrl: string;
    purchaserTwoSignatureDate: string;
    salesAgentSignatureUrl: string;
    salesAgentSignatureDataUrl: string;
    salesAgentSignatureDate: string;
    isSectionComplete?: boolean;
}
